import {IRouteLayerLocation} from '@toolify/client/src/modules/routes/types/IRouteLayerLocation'

export function shouldReplaceRouteLayerLocation(
  existing: IRouteLayerLocation | null | undefined,
  incomingDepth: number,
): boolean {
  if(!existing) {
    return true
  }
  return incomingDepth <= existing.depth
}
